var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"input",staticStyle:{"width":"50px"},attrs:{"type":"text"},domProps:{"value":_vm.nprefix},on:{"input":function (e) { return _vm.changePrefix(e.currentTarget.value); }}})}
var staticRenderFns = []

export { render, staticRenderFns }